const BASE_BACKOFF_MS = 30_000;
const MAX_BACKOFF_MS = 60 * 60 * 1000;

/**
 * Computes the next retry instant using exponential backoff from `retryCount`,
 * or an explicit `retryAfterSeconds` when the remote side supplied one.
 */
export function computeNextRetryAt(
  retryCount: number,
  retryAfterSeconds?: number,
  now = Date.now(),
): Date {
  if (retryAfterSeconds != null && retryAfterSeconds > 0) {
    return new Date(now + retryAfterSeconds * 1000);
  }

  const delayMs = Math.min(
    BASE_BACKOFF_MS * Math.pow(2, retryCount),
    MAX_BACKOFF_MS,
  );

  return new Date(now + delayMs);
}
